import { api } from "@/lib/api/client";
import type { components } from "@/types/api";

export type BillingStatus = Omit<components["schemas"]["BillingStatus"], "plan" | "quotas"> & {
  plan: components["schemas"]["BillingStatus"]["plan"] & {
    interval?: "monthly" | "annual" | null;
    billing_cycle_anchor?: string | null;
  };
  quotas: Omit<components["schemas"]["BillingStatus"]["quotas"], "max_storage_bytes"> & {
    max_storage_bytes: string | number;
  };
  usage?: {
    period: string;
    current_mad: number;
    mad_quota: number;
    mad_quota_used_pct: number;
    overage_estimate_cents: number;
    retention_days: number;
  };
};
export type BillingSessionUrl = components["schemas"]["BillingSessionUrl"];
export type BillingUsageHistory = components["schemas"]["BillingUsageHistoryResponse"];

export function getBillingStatus(): Promise<BillingStatus> {
  return api.get<BillingStatus>("/v1/billing/status");
}

export function getBillingUsageHistory(): Promise<BillingUsageHistory> {
  return api.get<BillingUsageHistory>("/v1/billing/usage/history");
}

export function createCheckoutSession(body: {
  plan: "pro" | "scale";
  interval?: "monthly" | "annual";
}): Promise<BillingSessionUrl> {
  return api.post<BillingSessionUrl>("/v1/billing/checkout", body, { retrySafe: true });
}

export function createPortalSession(): Promise<BillingSessionUrl> {
  return api.post<BillingSessionUrl>("/v1/billing/portal", {}, { retrySafe: true });
}
